import {EAutopaymentError, MIN_PAYKEEPER_AMOUNT} from './definitions';

export default {
  topUpBalance: 'Top up the account',
  stripeAutopaymentSettingsModal: {
    titleConnect: 'Activate auto payment',
    titleEdit: 'Configure auto payment',
    threshold: 'When balance is below',
    amount: 'Replenish balance with',
    minThreshold: 'The minimum balance is {{threshold}} {{currency}}',
    minAmount: 'The minimum deposit is {{amount}} {{currency}}',
    acceptanceInfo: 'Once applied, you will be redirected to the Stripe payment system website',
    licensesInfo:
      'We recommend that you set a minimum balance of <0>{{threshold}} {{currency}}</0>. This is the cost of all your licenses and the minimum payment for Viber, if any.',
    incorrectSettingsWarning:
      'The amount you set is not enough to renew the licenses on time. There may be interruptions in the operation of the service if the bank debits funds multiple times',
  },
  payKeeperSettingsModal: {
    title: 'Pay by card via the payment system',
    amount: 'Enter the amount to be credited',
    minAmount: `The minimum amount is ${MIN_PAYKEEPER_AMOUNT} {{currency}}`,
    chooseCard: 'Select a card',
    saveCard: 'Save the card for future payments',
    newCard: 'New card',
    replaceCard: 'Save a new card instead of the current one',
    acceptanceInfo: 'Clicking "Pay" will redirect you to the PayKeeper payment system website',
    pay: 'Pay',
  },
  payKeeperDeleteCardModal: {
    title: 'Delete saved card?',
    subtitle:
      'After deletion, you will need to re-enter your payment card details for the next payment',
    submit: 'Delete',
  },
  offAutopaymentModal: {
    title: 'Deactivate auto payment?',
    subtitle:
      'If you deactivate the auto payment, your licenses will no longer be automatically renewed. This means that you will not be able to use our services and send messages to your customers.',
    submitButton: 'Request deactivation',
  },
  supportModal: {
    title: {
      on: 'Activate auto payment?',
      off: 'Deactivate auto payment?',
    },
    subtitle:
      'Auto payment allows you to automatically add a specified amount of money to your balance using a bank card. Are you sure?',
    submitButton: {
      on: 'Activate',
      off: 'Deactivate',
    },
  },
  chargeAutopaymentModal: {
    title: 'Charge the unpaid invoice ',
    subtitle:
      'We’ll try to charge the unpaid invoice that previously failed due to an error. If there’s no open invoice, no charge will be made. Are you sure you want to proceed?',
    submitButton: 'Execute',
  },
  changeCardCreditsModal: {
    title: 'Edit card details for auto payment',
    subtitle:
      'To edit the linked card details, you will be redirected to the Stripe payment system website',
  },
  actions: {
    topUp: 'Top up',
    generateInvoice: 'Generate invoice',
    payByCard: 'Pay by card',
    deleteCard: 'Delete card',
    connectAutopayment: 'Activate auto payment',
    chargeAutopayment: 'Trigger charge',
    connectAutopaymentHint:
      'Auto payment allows you to automatically add a specified amount of money to your balance using a bank card',
    changeAutopaymentSettings: 'Edit auto payment',
    changeCardCredits: 'Edit card details',
    offAutopayment: 'Deactivate auto payment',
    restoreAutopayment: 'Resume auto payment',
  },
  info: 'When the balance is <1>{{threshold}}</1> <0>{{currency}}</0> it will be automatically replenished with <2>{{amount}}</2> <0>{{currency}}</0>',
  status: {
    connected: 'Auto payment activated',
    paused: 'Auto payment suspended',
    savedCard: 'Saved card',
  },
  thresholdWarning:
    'The set minimum balance may not be enough to cover your regular payments. We recommend that you update your auto payment to ensure that your licenses are renewed on time. <0>Update the auto payment</0>',
  invoiceSettingsModal: {
    title: 'Generate payment invoice',
    amount: 'Enter the amount for which you would like to get an invoice',
    warning:
      'When paying, please take into account all third-party fees for transfers and currency exchange operations.',
    generateButton: 'Generate',
    insertSum: 'Insert sum',
  },
  invoiceGeneratedModal: {
    title: 'Your invoice is ready',
    content: `We'll update your account balance when your payment is received. To download your invoice later, go to <0>Documents.</0>`,
    download: 'Download invoice',
  },
  stripeSettingsModal: {
    title: 'Pay by card with <0></0> payment system',
    topUp: 'Checkout',
    amount: 'Enter the amount',
    cancel: 'Cancel',
    warning:
      'Your payment will be credited to your current balance based on the offer. For any inquiries or issues, contact us at support@edna.io',
    content:
      'After pressing the “Checkout” button, you will be redirected to Stripe Checkout page to make your payment.',
  },
  errors: {
    onetimePayment: 'Error when adding funds to the account via card on {{date}}',
    [EAutopaymentError.INSUFFICIENT_FUNDS]:
      'The charge failed on {{date}}. Insufficient funds. Recharge your card within {{leftDays}} {{leftDays1}} to resume the auto payment. If the balance is insufficient after {{leftDays}} {{leftDays2}}, the auto payment will be disabled and the services will be suspended. The next charge will be on {{nextDate}}',
    [EAutopaymentError.CARD_DECLINE]:
      'Failed to make an auto payment with the linked card. Check the card details',
    [EAutopaymentError.AUTHENTICATION_REQUIRED]:
      'The auto payment failed on {{date}}. Your bank has requested payment confirmation. To confirm the payment, go to the <0>Stripe payment system website</0>.',
  },
};
